"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Drawer.default;
  }
});

var _Drawer = _interopRequireDefault(require("./Drawer"));


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/Drawer/index.js
// module id = 1536
// module chunks = 0